import { z } from "zod";
import { state } from "./ftthOrchestrator";

const orderSummary = z.object({
  totalOrderPrice: z.number(),
  totalRecurringOrderPrice: z.number(),
  totalOneTimeOrderPrice: z.number(),
  items: z.array(
    z
      .object({
        offerId: z.union([
          z.literal("NJU_FTTH_Subscription"),
          z.literal("P-NJU-Internet"),
        ]),
        offerPrice: z.number(),
        offerPriceType: z.literal("RECURRING"),
      })
      .or(
        z.object({
          offerId: z.union([
            z.literal("NJU_FTTH_NEOIASSYSKONF"),
            z.literal("P-NJU-Assistance"),
          ]),
          offerPrice: z.number(),
          offerPriceType: z.literal("ONE-TIME"),
        }),
      )
      .or(
        z.object({
          offerId: z.union([z.literal("NJU_FTTH_SFH"), z.literal("P-NJU-SFH")]),
          offerPrice: z.number(),
          offerPriceType: z.literal("RECURRING"),
        }),
      ),
  ),
});

export const ftthReactivationOrchestrator = z.object({
  type: z.literal("NJU_FTTH_REACTIVATION"),
  state,
  id: z.string(),
  products: z.object({
    id: z.string(),
    specificationId: z.literal("ACCESS"),
    vlocityOfferId: z.string(),
  }),
  orderSummary: orderSummary.optional(),
});

export type IFtthReactivationOrchestrator = z.infer<
  typeof ftthReactivationOrchestrator
>;
